import ContainedIcon from '@/components/ContainedIcon';
import QwenIconBase from '@/components/Icons/QwenIcon';
import { SharedEndpointModelFamily } from '@/graphql';

import {
  mapIconSizeToSize,
  mapModelFamilyToIconColor,
  mapModelFamilyToIconContainerColor,
} from '../utils';
import { SharedEndpointIconProps, SharedEndpointIconSize } from './types';

function QwenIcon({ size }: SharedEndpointIconProps) {
  const [containerSize, iconSize] = mapIconSizeToSize(size);

  return (
    <ContainedIcon
      size={containerSize}
      color={mapModelFamilyToIconContainerColor(SharedEndpointModelFamily.Qwen)}
      borderRadius={size === SharedEndpointIconSize.XSMALL ? 6 : 8}
    >
      <QwenIconBase
        sx={{
          width: iconSize,
          height: iconSize,
          color: mapModelFamilyToIconColor(SharedEndpointModelFamily.Qwen),
        }}
      />
    </ContainedIcon>
  );
}

export default QwenIcon;
